import { Badge } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import PublishIcon from '@mui/icons-material/Publish';
import UnpublishedIcon from '@mui/icons-material/Unpublished';
import { RowAction } from './row-action';

export function EditAction({ onClick, disabled }: { onClick: () => void; disabled?: boolean }) {
    return <RowAction title="Editar" onClick={onClick} disabled={disabled}><EditIcon fontSize="small" /></RowAction>;
}

export function DeleteAction({ onClick, disabled, title = 'Excluir' }: { onClick: () => void; disabled?: boolean; title?: string }) {
    return <RowAction title={title} color="error" onClick={onClick} disabled={disabled}><DeleteIcon fontSize="small" /></RowAction>;
}

export function VisibilityAction({ isVisible, onClick, disabled }: { isVisible: boolean; onClick: () => void; disabled?: boolean }) {
    return (
        <RowAction title={isVisible ? 'Ocultar no portal' : 'Exibir no portal'} onClick={onClick} disabled={disabled}>
            {isVisible ? <VisibilityIcon fontSize="small" /> : <VisibilityOffIcon fontSize="small" />}
        </RowAction>
    );
}

export function OpenLinkAction({ url, title = 'Abrir link' }: { url: string; title?: string }) {
    return (
        <RowAction title={title} onClick={() => window.open(url, '_blank', 'noopener,noreferrer')}>
            <OpenInNewIcon fontSize="small" />
        </RowAction>
    );
}

export function PublicationAction({ isPublished, onClick }: { isPublished: boolean; onClick: () => void }) {
    return (
        <RowAction title={isPublished ? 'Despublicar' : 'Publicar'} color={isPublished ? 'warning' : 'success'} onClick={onClick}>
            {isPublished ? <UnpublishedIcon fontSize="small" /> : <PublishIcon fontSize="small" />}
        </RowAction>
    );
}

// Contador de anexos que abre o drawer na seção de documentos
export function AttachmentsAction({ fileCount, onClick, emptyTitle = 'Anexar documentos' }: { fileCount: number; onClick: () => void; emptyTitle?: string }) {
    return (
        <RowAction title={fileCount > 0 ? `${fileCount} documento(s) anexado(s)` : emptyTitle} color={fileCount > 0 ? 'primary' : 'default'} onClick={onClick}>
            <Badge badgeContent={fileCount} color="primary" max={99}>
                <AttachFileIcon fontSize="small" />
            </Badge>
        </RowAction>
    );
}
